import { useEffect, useRef, useState } from 'react';
import api from '../../lib/api';

/** Authenticated images stay private: expand the fetched blob, never a public
 * raw URL. List thumbnails are not interactive (their parent is a button).
 */
export default function EditRequestShot({ path, alt, expandable = false }) {
  const [shot, setShot] = useState({ path: '', url: '', failed: false });
  const [fit, setFit] = useState(false);
  const dialog = useRef(null);
  useEffect(() => {
    if (!path) return undefined;
    let alive = true;
    let objectUrl = '';
    api.get(String(path).replace(/^\/api(?=\/)/, ''), { responseType: 'blob' })
      .then(({ data }) => {
        objectUrl = URL.createObjectURL(data);
        if (alive) setShot({ path, url: objectUrl, failed: false });
        else URL.revokeObjectURL(objectUrl);
      })
      .catch(() => { if (alive) setShot({ path, url: '', failed: true }); });
    return () => {
      alive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  const url = shot.path === path ? shot.url : '';
  if (!path) return <div className="er-shot-missing">No screenshot</div>;
  if (!url) return <div className="er-shot-missing" role="status">{shot.path === path && shot.failed ? 'Screenshot unavailable' : 'Loading screenshot…'}</div>;
  if (!expandable) return <img src={url} alt={alt} />;

  const open = () => { setFit(false); dialog.current?.showModal(); };
  return (
    <>
      <button type="button" className="er-shot-preview" onClick={open} aria-label={`Open full-size: ${alt}`}>
        <img src={url} alt={alt} />
        <span>Open full size</span>
      </button>
      <dialog ref={dialog} className="er-shot-dialog" aria-label={alt} onClick={(event) => {
        if (event.target === event.currentTarget) dialog.current?.close();
      }}>
        <header>
          <strong>{alt}</strong>
          <button type="button" onClick={() => setFit((value) => !value)}>{fit ? 'Actual size' : 'Fit to window'}</button>
          <button type="button" onClick={() => dialog.current?.close()} autoFocus aria-label="Close screenshot">Close</button>
        </header>
        <div className={`er-shot-dialog__viewport${fit ? ' is-fit' : ''}`} tabIndex={0} role="region" aria-label="Full-resolution screenshot; scroll to inspect">
          <img src={url} alt={alt} />
        </div>
      </dialog>
    </>
  );
}
